module.exports = __webpack_public_path__ + "static/img/bj13.e27d9d6e.png";